
portfolio.core.init_BANG_();